

class NotificationModel {
  static isSelfInvitation(notificationData) {
    return notificationData.shared_owner && notificationData.shared_owner.primary === 1;
  }
}

export default NotificationModel;
